export class ChequeDetail {
    chequeName: string;
    chequeNumber: string;
    amount: string;
}